import { IonButton, IonPopover } from "@ionic/react";
import { Trans } from "react-i18next";

const DeletionConfirmationPopover = ({ isOpen, onConfirm, onCancel }: { isOpen: boolean; onConfirm: () => void; onCancel: () => void }) => {
  return (
    <IonPopover
      isOpen={isOpen}
      onDidDismiss={onCancel}
      className="argumentInputPopover"
    >
      <div className="deleteConfimrationPopoverDiv p-6">
        <p className="deleteConfimrationPopoverTitle text-lg font-semibold text-gray-900 mb-6">
          <Trans>Vuoi eliminare davvero?</Trans>
        </p>
        
        <div className="deleteConfimrationPopoverBtns flex space-x-3">
          <IonButton
            className="deleteConfimrationPopoverButton flex-1 bg-red-500 text-white hover:bg-red-600"
            onClick={onConfirm}
          >
            <Trans>Conferma</Trans>
          </IonButton>
          
          <IonButton
            className="argumentDismissBtn flex-1 bg-gray-300 text-gray-700 hover:bg-gray-400"
            onClick={onCancel}
          >
            <Trans>Annulla</Trans>
          </IonButton>
        </div>
      </div>
    </IonPopover>
  );
};

export default DeletionConfirmationPopover;